import $ from 'jquery';
import TermsAndConditionsDialog from 'app/termsAndConditions/TermsAndConditionsDialog.view';
import { handleEnterAndSpace } from 'app/util/accessibilityUtils';

export default new (function () {
    $(document).ready(function () {
        var $termsLinks = $('.js-termsAndConditions');
        var showTermsAndConditions = function () {
            new TermsAndConditionsDialog(); // eslint-disable-line no-new
        };
        $termsLinks.off('click'); // safety measure
        $termsLinks.off('keydown'); // safety measure
        $termsLinks.on('click', showTermsAndConditions);
        $termsLinks.on('keydown', handleEnterAndSpace(showTermsAndConditions));
    });
})();
